import { IRole } from 'src/types';
import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from 'src/constants';

export interface ICreateRoleRequest {
  name: string;
  description?: string;
  permissions: string[];
}

export const createRole = async (role: ICreateRoleRequest): Promise<IRole> => {
  const response = await fetch(`${API_URL}/admin/roles`, {
    method: 'POST',
    body: JSON.stringify(role),
  });

  if (!response.ok) {
    const responseBody = await response.json().catch(() => null);
    throw new Error(responseBody?.message || 'Could not create role');
  }

  const responseBody = await response.json();
  return responseBody.data;
};
